import React from "react";
import { useState } from "react";
import Login from "./Login";
import image from "../logos/devices.png";
import "./CommonDashboard.css";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";


import CircularProgress from "@material-ui/core/CircularProgress";


import DeviceTable from "./DeviceTable";
import { setDevice } from "../redux/slices/deviceSlice";

import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";

function DeviceDashboard() {
  const [login, setLogin] = useState(false);
  const dispatch = useDispatch();
  const headers = useSelector((state) => state.header);
  const [apiloading, setApiLoading] = useState(true);
  const curremmsData = useSelector((state) => state.curremms);
  const api = localStorage.getItem("api");
  const emmsheaders = useSelector((state) => state.emmsheader);
  const curremms = curremmsData.curremms;
  const [selectedOption, setSelectedOption] = useState(curremms?.id);
  
  function fetchData() {
    axios
      .get(api + `/list/devices`, headers)
      .then((response) => {
        dispatch(setDevice(response.data));
        setApiLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }
  React.useEffect(() => {
    fetchData();
    handleMeetingData();
  }, [selectedOption]);

  const handleMeetingData = () => {
    const requestBody = {
      path: "meetingspace",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        dispatch(setMeetingSpaces(response?.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return login == null ? (
    <Login />
  ) : (
    <>
      {apiloading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className="mainContainer emms-main-container">
            <header>
              <figure>
                <img className="img" src={image} alt="Logo" />
              </figure>
            </header>

            <div className="tableAndButtonContainer">
              <div style={{ marginLeft: "10%" }}>
                <DeviceTable />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DeviceDashboard;
